class ApiAggregator {
  holders;
  constructor(...holders) {
    this.holders = holders;
  }
  get(apiRef) {
    for (const holder of this.holders) {
      const api = holder.get(apiRef);
      if (api) {
        return api;
      }
    }
    return void 0;
  }
}

export { ApiAggregator };
//# sourceMappingURL=ApiAggregator.esm.js.map
